import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { classes } from '../styles';
import { HomeStepTabs } from '../../ApplicationSummaries/QuestionsModal/HomeStep/HomeStep';

const ToggleButtons = ({
  value,
  setValue,
  options
}: {
  value: string;
  setValue: (value: HomeStepTabs) => void;
  options: {
    value: string;
    label: string;
  }[];
}) => {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(e, value) => {
        if (value === null) return;
        setValue(value as HomeStepTabs);
      }}
    >
      {options.map((button, index) => (
        <ToggleButton value={button.value} sx={classes.toggleButton} key={index}>
          {button.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleButtons;
